/* eslint-disable no-mixed-operators */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Tooltip, Dropdown, Menu } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import { faFillDrip, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { eventBus, FONT_SIZE, EDIT_MENU, renderTextLine, getLineLeftOffset } from '../../utils';
import './styles.scss';
import { KEYS_CODE } from '../../utils/keysCode';
import ColorPicker from '../ColorPicker';

const EditInput = ({ isShow, position, styles, editText }) => {
  const searching = useSelector((appState) => appState.board.searching);
  const isAllStyleTrue = (type) =>
    styles.length > 0
      ? styles.reduce((a, c) => a.concat(c[type]), []).every((v) => v === true || v === 'italic' || v === 'bold')
      : false;
  const checkType = (type) => {
    const isTrue = isAllStyleTrue(type);
    return isTrue;
  };
  const checkAllEquals = (key, value) => {
    const values = styles.reduce((a, c) => a.concat(c[key]), []);
    return values.every((v) => v === value);
  };
  const getFontSize = () => {
    if (styles.length === 0) {
      return 10;
    }
    const val = styles[0].fontSize;
    const isEqual = checkAllEquals('fontSize', val);
    return isEqual ? val : 0;
  };

  const isSuper = () => {
    const values = styles.reduce((a, c) => a.concat(c.deltaY), []);
    return values.every((v) => v < 0);
  };
  const isSub = () => {
    const values = styles.reduce((a, c) => a.concat(c.deltaY), []);
    return values.every((v) => v > 0);
  };
  const getColor = (type) => {
    const key = type === 'textBackgroundColor' ? 'textBackgroundColor' : 'fill';
    const value = styles[0][key];
    const isSame = checkAllEquals(key, value);
    return isSame ? value : '';
  };
  const initStyle = {
    fontWeight: checkType('fontWeight') ? 'bold' : '',
    fontStyle: checkType('fontStyle') ? 'italic' : '',
    underline: checkType('underline') || false,
    linethrough: checkType('linethrough') || false,
    superscript: isSuper(),
    subscript: isSub(),
    fontSize: getFontSize(),
    fill: styles.length > 0 ? getColor('fill') : '',
    textBackgroundColor: styles.length > 0 ? getColor('textBackgroundColor') : '',
  };
  const [style, setStyle] = useState(initStyle);
  const [listInfo, setListInfo] = useState({});
  const componentSettings = useSelector((state) => state.board.componentSettings);
  const offset = 10;
  const getNewVal = (type, val) => {
    let newVal = '';
    switch (type) {
      case 'fontWeight':
        newVal = val === 'normal' || val === '' ? 'bold' : 'normal';
        break;
      case 'fontStyle':
        newVal = val === 'normal' || val === '' ? 'italic' : 'normal';
        break;
      case 'underline':
      case 'linethrough':
      case 'superscript':
      case 'subscript':
        newVal = !val;
        break;
      default:
        break;
    }
    return newVal;
  };

  const onClick = (e) => {
    const curVal = style[e];
    const newVal = getNewVal(e, curVal);
    let data = null;
    const { listType, simulateList } = listInfo;
    if (['unorderList', 'orderList'].includes(e)) {
      let isSimulate;
      if (listType !== e) isSimulate = true;
      if (listType === e) isSimulate = !simulateList;
      data = {
        ...style,
        [e]: renderTextLine,
        simulateList: isSimulate,
        listType: e,
        lineOffset: getLineLeftOffset,
      };
      eventBus.emit('set-style-edited', {
        [e]: renderTextLine,
        simulateList: isSimulate,
        listType: e,
        lineOffset: getLineLeftOffset,
      });
      eventBus.emit('set-style-settings-form', data);
      setListInfo({
        simulateList: isSimulate,
        listType: e,
      });
    } else {
      data = {
        ...style,
        [e]: newVal,
      };
      eventBus.emit('set-style-edited', { [e]: newVal });
      eventBus.emit('set-style-settings-form', data);
    }
    setStyle(data);
  };
  const handleKeyDown = (event) => {
    console.log('-----handleKeyDown---EditInput---', searching);
    if (searching || !isShow) return;
    if (event.altKey && event.shiftKey && event.keyCode === KEYS_CODE.S) {
      onClick('linethrough');
    }
    if (event.ctrlKey || event.metaKey) {
      switch (event.keyCode) {
        case KEYS_CODE.B:
          onClick('fontWeight');
          break;
        case KEYS_CODE.U:
          onClick('underline');
          break;
        case KEYS_CODE.I:
          onClick('fontStyle');
          break;
        default:
          break;
      }
    }
  };
  useEffect(() => {
    if (styles) {
      setStyle(initStyle);
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [styles, searching]);
  useEffect(() => {
    if (editText) {
      const { listType, simulateList } = editText;
      setListInfo({
        listType,
        simulateList,
      });
    }
  }, [editText]);
  useEffect(() => {
    if (componentSettings) {
      let result = { ...componentSettings };
      Object.keys(componentSettings).forEach((item) => {
        result = { ...result, [item]: componentSettings[item] };
      });
      let data = result;
      if (result.simulateList) {
        data = { ...data, simulateList: result.simulateList || false };
      }
      setListInfo({
        listType: result.listType,
        simulateList: result.simulateList,
      });
      setStyle(data);
    }
  }, [componentSettings]);
  const handleActiveBtn = (type) => {
    switch (type) {
      case 'fontWeight':
        return style && style.fontWeight === 'bold';
      case 'fontStyle':
        return style && style.fontStyle === 'italic';
      case 'underline':
        return style && style.underline;
      case 'linethrough':
        return style && style.linethrough;
      case 'superscript':
        return style && style[type];
      case 'subscript':
        return style && style[type];
      case 'unorderList':
        return listInfo.simulateList && listInfo.listType === 'unorderList';
      case 'orderList':
        return listInfo.simulateList && listInfo.listType === 'orderList';
      default:
        return false;
    }
  };

  function handleMenuClick(e) {
    const newFontSize = FONT_SIZE[e.key];
    eventBus.emit('set-style-edited', { fontSize: newFontSize });
    setStyle((oldS) => ({
      ...oldS,
      fontSize: newFontSize,
    }));
    eventBus.emit('set-style-settings-form', {
      ...style,
      fontSize: newFontSize,
    });
  }
  const onChange = (v, type) => {
    const key = type === 'textBackgroundColor' ? 'textBackgroundColor' : 'fill';
    const obj = { [key]: v };
    eventBus.emit('set-style-edited', obj);
    setStyle((oldS) => ({
      ...oldS,
      ...obj,
    }));
    eventBus.emit('set-style-settings-form', {
      ...style,
      ...obj,
    });
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {FONT_SIZE.map((f, index) => (
        <Menu.Item key={index} style={{ backgroundColor: f === style.fontSize ? '#4eccf5' : 'inherit' }}>
          {f}
        </Menu.Item>
      ))}
    </Menu>
  );

  const renderEdit = () =>
    Object.keys(EDIT_MENU).map((e, i) => (
      <Tooltip key={i} title={EDIT_MENU[e].tooltipLabel} placement="topLeft">
        {EDIT_MENU[e].type === 'button' && (
          <Button
            className={handleActiveBtn(e) ? 'btn-active' : 'text-btn'}
            icon={EDIT_MENU[e].icon}
            type="text"
            onClick={() => onClick(e)}
          />
        )}
        {EDIT_MENU[e].type === 'input' && (
          <ColorPicker onChange={onChange} type="fill" color={style.fill ?? getColor('fill')} icon={faPencilAlt} />
        )}
        {EDIT_MENU[e].type === 'dropdown' && (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button type="text" style={{ padding: '5px' }}>
              {style.fontSize ? Math.round(style.fontSize * 100) / 100 : String.fromCharCode(0x12014)}
              {''}
              <CaretDownOutlined />
            </Button>
          </Dropdown>
        )}
        {EDIT_MENU[e].type === 'color' && (
          <ColorPicker
            onChange={onChange}
            type="textBackgroundColor"
            color={style.textBackgroundColor ?? getColor('textBackgroundColor')}
            icon={faFillDrip}
          />
        )}
      </Tooltip>
    ));

  return (
    styles.length > 0 && (
      <div
        className="mo__edit-text-panel grid-2-cols"
        style={{
          display: isShow ? 'flex' : 'none',
          ...(position ? { position: 'absolute', top: position.top ? position.top - offset - 40 : {}, left: position.left ? position.left : {} } : {}),
        }}
      >
        <div className="mo__edit-text-group">{renderEdit()}</div>
      </div>
    )
  );
};

export default EditInput;
